import { handleActions } from 'redux-actions';
import { reduxKey } from '../constants';
import { SocialLoginState } from '../types';
import { setSocialLoginError, initializeFacebookJSSDK } from './actions';

const initialState: SocialLoginState = {};

const handler = handleActions<SocialLoginState, any>(
  {
    [`${setSocialLoginError}`]: (state, action) => ({
      ...state,
      error: action.payload.errorCode,
    }),
    [`${initializeFacebookJSSDK}`]: (state, action) => ({
      ...state,
      isFacebookSDKInitialized: true,
    }),
  },
  initialState
);

export default {
  [reduxKey as string]: handler,
};
